import { render, staticRenderFns } from "./SettingsTariffs.vue?vue&type=template&id=c8b29d7e"
import script from "./SettingsTariffs.vue?vue&type=script&lang=js"
export * from "./SettingsTariffs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports